import { useMemo } from 'react';
import type { ToolCatalogEntry } from '../types';
import { TOOL_CATALOG, filterForAgentType } from '../catalog';

/**
 * Read-only access to the generated tool catalog (the code-defined projection
 * of the backend ActionRegistry). The editable overlay — per-tool description
 * and level overrides — will arrive as a persisted toolset domain; until then
 * the catalog cannot be mutated here.
 */
export const toolCatalogStore = {
  getAll(): ToolCatalogEntry[] {
    return TOOL_CATALOG;
  },
  getByActionId(actionId: string): ToolCatalogEntry | undefined {
    return TOOL_CATALOG.find((e) => e.actionId === actionId);
  },
  forAgentType(agentType: 'investigation' | 'automation' | 'both'): ToolCatalogEntry[] {
    return filterForAgentType(TOOL_CATALOG, agentType);
  },
};

export const useToolCatalog = () => useMemo(() => toolCatalogStore, []);
